export default {
  document: {
    name: 'Document',
    search: {
      errors: {
        bilans: 'Please select',
        typeDocument: 'Please select',
      },
    },
    list: {
      title: 'List of document',
      downloadHover: 'Download',
      expandHover: 'Attached documents',
      eyeHover: 'Preview',
      noDataText: 'No documents match the search criteria',
      headers: {
        libelleDocument: 'Wording',
        nomDocument: 'Name of the document',
        dateCreation: 'Creation date',
        typeDocument: 'Type',
        typeDocumentSearch: 'Choose the type of document',
        age: 'Document age',
        bilans: 'Choose The balance sheets to display',
        selectAll: 'Select All',
      },
      enums: {
        age: {
          onemonth: 'Act of less than 1 month',
          threemonths: 'Act of less than 3 months',
          sixmonths: 'Act of less than 6 months',
          heigthmonths: 'Act of less than 8 months',
          onsyear: 'Act of less than 1 year',
          twoyears: 'Act of less than 2 years',
          threeyears: 'Act of less than 3 years',
        },
      },
    },
    send: {
      title: 'Send document(s)',
      dialog: {
        mail: 'Send(s) document(s) by mail to : ',
        password: 'Password requested when opening files : ',
        data: 'The documents you send are transmitted under your own liability',
      },
      input: {
        mail: 'Adresse mail',
        myself: 'My mail',
        password: 'Password',
      },
      enCours: 'Send in progress',
      success: 'Document(s) sends',
    },
    error: {
      typedocument:
        'An error occurred while retrieving the list of document types. Please contact CIEM.',
      selectdocument: 'An error occurred while downloading the document.',
      selectDocuments: 'An error occurred while downloading the documents.',
      mail: 'An error occurred while retrieving your email.',
      bilans: 'An error occurred while retrieving the health check-up list.',
    },
  },
}
